<template>
  <div
    v-scroll="handleScroll"
    class="inner-chat"
    data-qa="inner-chat">
    <div class="comments-col-1"/>
    <div class="comments-col-2">
      <ChatTemplate
        ref="chatTemplate"
        :chat="!tender.hasRoute"
        :disabled="!tender || !tender.tenderId"
        file-show
        :files.sync="files"
        :loading="loading"
        :text.sync="text"
        @send="send">
        <div
          slot="title"
          class="flex width-100">
          <div
            class="inner-chat-head-title"
            data-qa="particpantOrganizationTitle">
            {{ `#${tender.tenderNumber}. ${tender.title}` }}
          </div>
        </div>
        <template v-slot:items>
          <InnerChatCards
            mode="modal"
            sort="desc"
            :value="value"
            @answer="answerValue => answerComment = answerValue"
            @changeViewedMessages="$_changeViewedMessages"
            @loadPage="$emit('loadPage')"/>
        </template>

        <HistoryInnerChatInput
          slot="chatInput"
          class="inner-chat_input"
          :files.sync="files"
          :hash-items="sprHashItems"
          :key-after="'-full'"
          :loading="loading"
          :style="`height: ${innerHeight};`"
          :text.sync="text"
          :user-items="sprUsers"
          @resize="resize"
          @send="send">
          <template
            v-slot:beforeInput>
            <CommentInputBlock
              :loading="loading"
              :value="answerComment ? {title: answerComment.userLogin} : null"
              @close="answerComment = null">
              <InnerChatMessage
                slot="message"
                readonly
                :value="answerComment"/>
            </CommentInputBlock>
          </template>
        </HistoryInnerChatInput>
      </ChatTemplate>
    </div>
  </div>
</template>
<script>
import ChatTemplate from 'components/common/blocks/history/ChatTemplate.vue'
import InnerChatCards from 'components/common/blocks/inner-chat/InnerChatCards.vue'
import CommentInputBlock from 'components/common/blocks/history/CommentInputBlock.vue'
import InnerChatMessage from 'components/common/blocks/inner-chat/InnerChatMessage.vue'
import HistoryInnerChatInput from 'components/common/blocks/inner-chat/HistoryInnerChatInput.vue'

import { debounce } from 'toolkit/utils/util'
import { mapGetters } from 'vuex'
import { innerChatMixin, doomMixin } from 'mixins'

export default {
  name: 'dialogInnerChat',
  mixins: [innerChatMixin, doomMixin],
  data() {
    return {
      innerHeight: '98px',
      element: null,
      files: [],
      loading: false,
      answerComment: null,
      text: null
    }
  },
  methods: {
    resize(val) {
      this.$nextTick(() => {

        const maxHeight = (document.documentElement.offsetHeight / 2 ) - 55

        const height = val > maxHeight ? maxHeight : val
        this.$refs.chatTemplate.resize(height - 50)
        this.innerHeight = `${height}px`
      })
    },
    handleScroll: debounce(async function () {
      const that = this
      if (that.value.messages?.length < that.value.messagesCount) {
        const blocks = document.getElementsByClassName('inner-chat-card')

        let lastKey = null
        Array.prototype.forEach.call(blocks, function(element) {
          if (!lastKey && that.$_isScrolledIntoView(element)) {
            lastKey = parseInt(element.getAttribute('index'))
          }
        })
        if (lastKey <= 2) {
          that.$emit('loadPage')
        }
      }
    }, 250),
    scrollSubs() {
      if (this.element) {
        this.element.addEventListener('scroll', this.handleScroll, false)
      }
    },
    scrollUnSubs() {
      if (this.element) {
        this.element.removeEventListener('scroll', this.handleScroll, false)
      }
    },
    send: debounce(async function (messageObject) {
      if (this.answerComment) {
        messageObject.parentMessageId = this.answerComment.id
      }
      const modelMessage = {
        entity: {
          entityType: 'Tender',
          entityId: this.tender.tenderId.toString(),
          properties: [
            {'key': 'NUMBER','value': this.tender.tenderNumber.toString()},
            {'key': 'TITLE','value': this.tender.title},
            {'key': 'ORGANIZATION_IT_ID','value': this.tender.organizer.organizationItId.toString()},
          ]
        },
        messag: messageObject
      }
      this.$_sendNewMessage(modelMessage).then(() => {
        this.answerComment = null
        this.files = []
        this.scrollToLastItem()
      })
        .catch(() => {
          this.text = messageObject.value
        })
    }, 250),
    scrollToLastItem() {
      setTimeout(() => {
        let items = document.getElementsByClassName('inner-chat-card not-read mode-modal')
        if (items?.length) {
          items[0].scrollIntoView({block: 'center', behavior: 'smooth'})
        } else {
          items = document.querySelectorAll('[index="0"]')
          let lastItem
          Array.from(items).forEach((item) => {
            if (item.classList.contains('mode-modal')) {
              lastItem = item
            }
          })
          if (lastItem) {
            lastItem.scrollIntoView({block: 'center', behavior: 'smooth'})
          }
        }
      }, 250)
    }
  },
  computed: {
    ...mapGetters({
      stored_current_organization: 'getCurrentOrganization',
      user: 'GET_USER',
    }),
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    show: {
      type: Boolean
    },
    tender: {
      type: Object
    },
  },
  watch: {
    items: {
      deep: true,
      handler() {
        this.scrollToLastItem()
      }
    },
    show: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.scrollToLastItem()
        }
      }
    }
  },
  created() {
    this.scrollToLastItem()
  },
  mounted() {
    this.element = document.getElementsByClassName('inner-chat-items')[0]
    this.scrollSubs()
    this.$refs.chatTemplate.resize(48)
  },
  beforeDestroy() {
    this.scrollUnSubs()
  },
  components: {
    ChatTemplate,
    InnerChatCards,
    InnerChatMessage,
    CommentInputBlock,
    HistoryInnerChatInput
  }
}
</script>
<style scoped lang="scss">
@import 'toolkit/style/variables.scss';

.inner-chat {
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  flex-wrap: wrap;
  height: 100%;
  overflow: auto;
  &_input {
    position: relative;
    border-top: 2px solid var(--color-main-green);
    padding: 10px 10px 0px 10px;
    width: 100%;
    z-index: 1;
    background: var(--v-main__light_green-base);
    &::v-deep .chat-input-count {
      margin-top: 2px;
    }
  }
  &::v-deep .history-items{
    padding: 0;
  }
}

.comments-col-1 {
	width: 0%;
	height: 100%;
}
.comments-col-2 {
	height: 100%;
	overflow: auto;
	overflow-x: hidden;
	display: flex;
	position: relative;
	flex-wrap: wrap;
	border-radius: 8px;
	align-content: flex-start;
	align-content: space-between;
	background: var(--v-main__light_green-base);
	width: 100%;
}
</style>
